import React from 'react'
import {MenuLink} from '@src/modules/Layout/shared/MenuLink'
import {REVIEW_ROUTES} from '../../constants'
import {Icon} from '@therms/atalaya'
import {MdOutlineSummarize} from 'react-icons/md'
import {useCurrentUserAnPCheck} from '@therms/react-modules'

function ReviewMenuLink() {
  if (!useCurrentUserAnPCheck(({anp}) => anp.role.ops.access.viewOpsSummary)) {
    return null
  }

  return (
    <MenuLink to={REVIEW_ROUTES.__ROOT__}>
      <div className="gap-x-sm inline-flex items-center">
        <Icon Icon={MdOutlineSummarize} size="sm" />
        <span>Review</span>
      </div>
    </MenuLink>
  )
}

export {ReviewMenuLink}
